"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _get3 = _interopRequireDefault(require("@babel/runtime/helpers/get"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _Cookies = _interopRequireDefault(require("Cookies"));

var _AppLoginDao = _interopRequireDefault(require("./dao/AppLoginDao"));

var _BaseCookieLogin2 = _interopRequireDefault(require("../BaseCookieLogin"));

var COOKIE_LOAD_BALANCERS = ['app', 'api'];
var VISIT_PATH = '/login-api/v1/login/visit';
var COOKIE_VERIFIED_KEY = 'cookieverified';

var AppCookieLogin =
/*#__PURE__*/
function (_BaseCookieLogin) {
  (0, _inherits2.default)(AppCookieLogin, _BaseCookieLogin);

  function AppCookieLogin(options) {
    var _this;

    (0, _classCallCheck2.default)(this, AppCookieLogin);

    var _ref = options || {},
        loginRequest = _ref.loginRequest,
        passThroughFallback = _ref.passThroughFallback;

    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(AppCookieLogin).call(this, COOKIE_LOAD_BALANCERS, loginRequest || _AppLoginDao.default.login, _AppLoginDao.default.prep, VISIT_PATH));
    _this.passThroughFallback = passThroughFallback || false;
    return _this;
  }

  (0, _createClass2.default)(AppCookieLogin, [{
    key: "loginRequests",
    value: function loginRequests(credentials) {
      var _this2 = this;

      this.credentials = credentials;

      if (credentials.passThrough) {
        return this.passThroughLogin(credentials);
      }

      return this.cookieLoadBalancers.map(function (loadBalancer) {
        // TODO: remove catching the failure when CORS is reliable across our supported cases -- well, a girl can dream anyway
        if (loadBalancer === 'api') {
          return _this2.loginRequest(credentials, loadBalancer).catch(function (error) {
            console.error(error);
          });
        } else {
          return _this2.loginRequest(credentials, loadBalancer);
        }
      });
    }
  }, {
    key: "collectLoginResponses",
    value: function collectLoginResponses() {
      var _get2;

      for (var _len = arguments.length, loginResponses = new Array(_len), _key = 0; _key < _len; _key++) {
        loginResponses[_key] = arguments[_key];
      }

      (_get2 = (0, _get3.default)((0, _getPrototypeOf2.default)(AppCookieLogin.prototype), "collectLoginResponses", this)).call.apply(_get2, [this].concat(loginResponses));

      var twoFactorRequired = loginResponses.length > 0 && loginResponses[0].status === 'TWO_FACTOR_REQUIRED';

      if (!this.credentials.passThrough && !twoFactorRequired) {
        return this.verifyCookie({
          loginResponses: loginResponses,
          firstAttempt: true
        });
      }

      return loginResponses;
    }
  }, {
    key: "verifyCookie",
    value: function verifyCookie(_ref2) {
      var _this3 = this;

      var loginResponses = _ref2.loginResponses,
          firstAttempt = _ref2.firstAttempt;
      var verifyParameters = {
        firstAttempt: firstAttempt
      };

      if (this.credentials) {
        verifyParameters.email = this.credentials.email;
      }

      return _AppLoginDao.default.verify(verifyParameters).then(function () {
        return true;
      }).catch(function (error) {
        console.error(error);
        return false;
      }).then(function (cookieVerified) {
        _Cookies.default.set(COOKIE_VERIFIED_KEY, cookieVerified ? '1' : '0', {
          path: '/',
          secure: true,
          expires: 365,
          domain: _this3.currentDomain
        });

        if (_this3.passThroughFallback && !cookieVerified) {
          return _this3.passThroughLogin(_this3.credentials);
        } else {
          return loginResponses;
        }
      });
    }
  }, {
    key: "passThroughLogin",
    value: function passThroughLogin(credentials) {
      var _this4 = this;

      var passThroughCredentials = (0, _extends2.default)({}, credentials, {
        passThrough: true
      });
      return this.loginRequest(passThroughCredentials, 'app').then(function (response) {
        _Cookies.default.set('csrf.app', response.csrfToken, {
          path: '/',
          secure: true,
          expires: 365,
          domain: _this4.currentDomain
        });

        return [response];
      });
    }
  }, {
    key: "redirectOnLoginSuccess",
    value: function redirectOnLoginSuccess(_ref3) {
      var _ref4 = (0, _slicedToArray2.default)(_ref3, 1),
          redirectUrl = _ref4[0].redirectUrl;

      window.location = redirectUrl;
    }
  }]);
  return AppCookieLogin;
}(_BaseCookieLogin2.default);

var _default = AppCookieLogin;
exports.default = _default;
module.exports = exports.default;